@if (screenLayoutService.desktopAny$ | async) {
  <app-service-tickets-table-desktop
    [tickets]="tickets()"
    (sortChange)="onSortChange($event)"
  ></app-service-tickets-table-desktop>
} @else {
  <app-service-tickets-table-mobile
    [tickets]="tickets()"
  ></app-service-tickets-table-mobile>
}
